import { render, staticRenderFns } from "./BancaEmaticaTipiOperatoriEdit.vue?vue&type=template&id=77c3bf40"
import script from "./BancaEmaticaTipiOperatoriEdit.vue?vue&type=script&lang=js"
export * from "./BancaEmaticaTipiOperatoriEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports